import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/SalonDetailClient.tsx");
